import React from "react";
import TextInput from "../../Components/Inputs/TextInput";
import TextareaInput from "../../Components/Inputs/TextareaInput";

export default function ({register, watch, errors}) {

  return (<>
    <TextInput
      label="Name"
      name="name"
      className="col-md-12 col-sm-6"
      register={register}
      readOnly={true}
      errorMessage={errors?.name}
    />
    <TextInput
      label="Surname"
      name="surname"
      className="col-md-12 col-sm-6"
      register={register}
      readOnly={true}
      errorMessage={errors?.surname}
    />
    <TextInput
      label="Phone"
      name="phone"
      className="col-md-12 col-sm-6"
      register={register}
      readOnly={true}
      errorMessage={errors?.phone}
    />
    <TextInput
      label="Email"
      name="email"
      className="col-md-12 col-sm-6"
      register={register}
      readOnly={true}
      errorMessage={errors?.email}
    />
    <TextInput
      label="Company name"
      name="company_name"
      className="col-md-12 col-sm-6"
      register={register}
      readOnly={true}
      errorMessage={errors?.company_name}
    />
    <TextInput
      label="Company Id"
      name="company_id"
      className="col-md-12 col-sm-6"
      register={register}
      readOnly={true}
      errorMessage={errors?.company_id}
    />
    <TextareaInput
      label="Comment"
      name="comment"
      className="col-md-12 col-sm-6"
      register={register}
      watch={watch}
      readOnly={true}
      errorMessage={errors?.comment}
    />
  </>);
}